import { makeStyles } from 'tss-react/mui';
import { sizeStyles } from './moneyRendererV3.constants';
import { MoneyRendererV3Props } from './moneyRendererV3.types';

export const useMoneyRendererV3Styles = makeStyles<
  Pick<MoneyRendererV3Props, 'size' | 'promotionTextColor'>
>()((theme, { size = 'small', promotionTextColor }) => ({
  cents: {
    ...sizeStyles[size].cents,
    fontWeight: theme.typography.fontWeightMedium as number,
  },
  principalPriceStyle: {
    ...sizeStyles[size].principal,
  },
  promotionStyle: {
    ...sizeStyles[size].promotion,
    color: promotionTextColor || theme.palette.text.secondary,
  },
}));
